// svc-offer `app_exclusive` schedule rules (src/api/v1/validators/scheduleValidator.js in svc-offer).
export const APP_EXCLUSIVE_SCHEDULE_TYPE = 'app_exclusive';
export const APP_EXCLUSIVE_BRAND = 'luxuryescapes';
// Every region's slot starts at 6:00am Sydney time, so the calendar is drawn in Sydney time.
export const APP_EXCLUSIVE_TIMEZONE = 'Australia/Sydney';
// Hour of day (Sydney) each daily slot starts and ends.
export const APP_EXCLUSIVE_START_HOUR = 6;
